import InstitutionExpertise from './institution-expertise';

export default InstitutionExpertise;
